import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  variablesViewColumns,
  mapVariablesViewQuery,
} from "./VariablesView.default";
import { getVariables } from "../repository/data.repository";
import { ContentType, VariableType } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createGridRequest } from "../hooks/useGridRequest";
import { enumRequest } from "../utils/options";

export interface VariablesViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
  readonly onAction?: (key: string, record: any) => void;
}

function VariablesView(props: VariablesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={variablesViewColumns}
      mapQuery={mapVariablesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getVariables, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "name", label: "Name" },
              { type: "textbox", name: "description", label: "Description" },
              { type: "textbox", name: "tag", label: "Tag" },
              {
                type: "combobox",
                name: "contentType",
                label: "Content Type",
                request: enumRequest(ContentType),
              },
              {
                type: "combobox",
                name: "variableType",
                label: "Variable Type",
                request: enumRequest(VariableType),
              },
              { type: "textbox", name: "value", label: "Value" },
            ],
          },
        ],
      }}
      actions={(record) => {
        // System variables are platform-managed (resolved at send-time) — they can't be edited or
        // deleted; only Custom variables are author-editable.
        const isSystem = record?.variableType === VariableType.System;
        return [
          {
            key: "update",
            label: "Edit",
            disabled: isSystem || !permissions.can("TemplatesVariables", "edit"),
            handler: (key, record) => props.onAction?.(key, record),
          },
          {
            key: "delete",
            label: "Delete",
            disabled: isSystem || !permissions.can("TemplatesVariables", "delete"),
            danger: true,
            handler: (key, record) => props.onAction?.(key, record),
          },
        ];
      }}
    />
  );
}

export default VariablesView;
